<template>
  <div class="grid grid-cols-1 mt-8 gap-y-4">
    <line-chart
      title="% Cajas rechazadas por proveedor (Semanal)"
      :categories="this.weeks"
      :series="percentage_rejected_series"
    ></line-chart>

    <line-chart
      title="Cajas Rechazadas por cada 100 exportadas (Semanal)"
      :categories="this.weeks"
      :series="percentage_rejected_by_exported_series"
    ></line-chart>
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_reports/process/show_process.js";

import LineChart from "@/components/views/layout/quality_reports/LineChart.vue";

export default {
  name: "QualityReportsContainerProviderShowProcessGraphics",

  components: {
    LineChart
  },

  data() {
    return {
      rejected_series: [],
      weeks: []
    }
  },

  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true }
  },

  computed: {
    percentage_rejected_series: function () {
      let series = [...this.rejected_series];
      return series.map(item => {
        return {
          name: item.name,
          color: item.color,
          data: item.percentages.slice(0, -1)
        };
      });
    },

    percentage_rejected_by_exported_series: function () {
      let series = [...this.rejected_series];
      return series.map(item => {
        return {
          name: item.name,
          color: item.color,
          data: item.percentage_rejected_exported.slice(0, -1)
        };
      });
    }
  },
  methods: {
    fetchRejectedPercentage: async function () {
      let response = await Requester.fetchRejectedPercentage(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.rejected_series = response.data.provider_series;
      this.weeks = response.data.weeks;

      this.load_data_general = true;
    },
  },
  mounted() {
    this.fetchRejectedPercentage();
  }
};
</script>
